<template>
  <v-row>
    <v-col xl="6" lg="6" md="8" sm="12">
      <v-card class="m-2">
        <v-card-text>
          <v-row>
            <v-col sm="4" md="2">
              <v-subheader class="c-label">Name</v-subheader>
              <v-subheader class="c-label">Konto</v-subheader>
              <v-subheader class="c-label">Kontotyp</v-subheader>
            </v-col>
            <v-col>
              <v-text-field
                  class="hide-label"
                  v-model="hh.name"
                  :rules="rules.name"
                  counter
                  maxlength="50"
                  hint="Der Name des Kontos"
                  label="Name"
                  @input="$emit('change', hh.id)"
              ></v-text-field>
              <v-text-field
                  class="hide-label"
                  v-model="hh.account"
                  :rules="rules.account"
                  counter
                  maxlength="50"
                  hint="Kontonummer"
                  label="Name"
                  @input="$emit('change', hh.id)"
              ></v-text-field>
              <v-select
                  class="hide-label"
                  v-model="hh.in_out"
                  :items="inOutOptions"
                  label="Kontotyp"
                  hint="Der Typ des Kontos"
                  :item-value="'value'"
                  :item-text="'text'"
                  @input="$emit('change', hh.id)"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "hh_detail",
  props:{
    item: {
      type: Object,
      default: () => {
        return {
          id: '',
          bis_id: '',
          name: '',
          account: '',
          in_out: 'A',
        }
      }
    },
  },
  data () {
    return {
      hh: {
        id: '',
        bis_id: '',
        name: '',
        account: '',
        in_out: 'A',
      },
      canEdit: false,
      inOutOptions: [{text: "Einnahmen", value: "E"}, {text: "Ausgaben", value: "A"}, {text: "Einnahmen/Ausgaben", value: "X"}],
      rules: {
        name: [val => (val || '').length > 0 || '*erforderlich'],
        account: [val => (val || '').length > 0 || '*erforderlich'],
      },
    }
  },
  watch: {
    item: {
      handler: function (newVal) {
        this.hh = {...newVal};
      },
      deep: true
    },
  },
  mounted() {
    this.canEdit = this.$cookies.get("ps_username") === 'admin';
    this.hh = {...this.item};
  },
  methods: {
    isValid() {
      return this.hh.name.trim().length > 0 && this.hh.account.trim().length;
    },
    resetEdit() {
      this.hh = {...this.item};
    },
    getData() {
      return this.hh;
    }
  }
}
</script>

<style scoped>
::v-deep .theme--light.v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.86);
}

::v-deep .hide-label {
  padding-top: 0px !important;
}

::v-deep .hide-label .v-label {
  display: none !important;
}

.c-label {
  margin-bottom: 10px;
  color: black;
  font-size: 14px;
  font-weight: 500;
}
</style>
